var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"map-container"},[_c('v-card',{ref:"map",staticClass:"map pa-2"}),_c('NoLocationAlert',{attrs:{"showError":_vm.showLocationError,"filename":_vm.currentImage.filename}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }